export enum PriceListDay {
  Mon = "Mon",
  Tue = "Tue",
  Wed = "Wed",
  Thu = "Thu",
  Fri = "Fri",
  Sat = "Sat",
  Sun = "Sun",
  BusinessDay = "BusinessDay",
  Weekends = "Weekends",
  SqueezedDay = "SqueezedDay",
  DayBeforeHoliday = "DayBeforeHoliday",
  NearestWeekdayBeforeHoliday = "NearestWeekdayBeforeHoliday",
  DayAfterHoliday = "DayAfterHoliday",
  NearestWeekdayAfterHoliday = "NearestWeekdayAfterHoliday",
  DayBeforeMajorHoliday = "DayBeforeMajorHoliday",
  DayAfterMajorHoliday = "DayAfterMajorHoliday",
  NearestWeekdayAfterGreatHoliday = "NearestWeekdayAfterGreatHoliday",
  Holiday = "Holiday",
  MajorHoliday = "MajorHoliday",

  AnyTime = "AnyTime",

  DayBeforeNewYearsEve = "DayBeforeNewYearsEve",
  NewYearsEve = "NewYearsEve",
  NewYearsDay = "NewYearsDay",
  WeekdayAfterNewYearsDay = "WeekdayAfterNewYearsDay",
  WeekdayBeforeTwelfthDay = "WeekdayBeforeTwelfthDay",
  TwelfthDay = "TwelfthDay",
  WeekdayAfterTwelfthDay = "WeekdayAfterTwelfthDay",
  DayBeforeEasterFriday = "DayBeforeEasterFriday",
  EasterFriday = "EasterFriday",
  EasterSaturday = "EasterSaturday",
  EasterSunday = "EasterSunday",
  EasterMonday = "EasterMonday",
  DayAfterEasterMonday = "DayAfterEasterMonday",
  WeekdayBeforeFirstOfMay = "WeekdayBeforeFirstOfMay",
  FirstOfMay = "FirstOfMay",
  WeekdayAfterFirstOfMay = "WeekdayAfterFirstOfMay",
  WeekdayBeforeAscensionDay = "WeekdayBeforeAscensionDay",
  AscensionDay = "AscensionDay",
  WeekdayAfterAscensionDay = "WeekdayAfterAscensionDay",
  DayBeforeWhitesunDay = "DayBeforeWhitesunDay",
  WhitsunEve = "WhitsunEve",
  WhitSunday = "WhitSunday",
  WhitMonday = "WhitMonday",
  DayAfterWhitsunMonday = "DayAfterWhitsunMonday",
  WeekdayBeforeSwedensNationalDay = "WeekdayBeforeSwedensNationalDay",
  SwedensNationalDay = "SwedensNationalDay",
  WeekdayAfterSwedensNationalDay = "WeekdayAfterSwedensNationalDay",
  DayBeforeMidsummerEve = "DayBeforeMidsummerEve",
  MidsummerEve = "MidsummerEve",
  MidsummerDay = "MidsummerDay",
  WeekdayAfterMidsummerDay = "WeekdayAfterMidsummerDay",
  WeekdayBeforeAllSaintsDay = "WeekdayBeforeAllSaintsDay",
  AllSaintsDay = "AllSaintsDay",
  DayBeforeChristmasEve = "DayBeforeChristmasEve",
  ChristmasEve = "ChristmasEve",
  ChristmasDay = "ChristmasDay",
  BoxingDay = "BoxingDay",
  WeekdayAfterBoxingDay = "WeekdayAfterBoxingDay"
}

export enum PriceListWorkType {
  Active = "Active",
  Normal = "Normal",
  OnCall = "OnCall",
  OnCallJour = "OnCallJour",
  OnCallBer = "OnCallBer",
  OnCallA = "OnCallA",
  OnCallB = "OnCallB",
  OnCallPassive = "OnCallPassive",
  Overtime = "Overtime",
  ChildAndYouthInvestigation = "ChildAndYouthInvestigation",
  InvestigationWithinSchool = "InvestigationWithinSchool",
  AdultInvestigation = "AdultInvestigation",
  BasicInvestigation = "BasicInvestigation",
  AutismInvestigation = "AutismInvestigation",
  ChildAndAdolescentInvestigationADHDADD = "ChildAndAdolescentInvestigationADHDADD",
  ChildAndAdolescentInquiryAutism = "ChildAndAdolescentInquiryAutism",
  AdultEducationADHDADD = "AdultEducationADHDADD",
  AdultStudiesAutism = "AdultStudiesAutism",
  PsychologicalInvestigation = "PsychologicalInvestigation",
  NeuropsychiatricExaminationChildrenAndYoungPeople = "NeuropsychiatricExaminationChildrenAndYoungPeople",
  NeuropsychiatricExaminationAdults = "NeuropsychiatricExaminationAdults",
  MedicalExamination = "MedicalExamination",
  NeuropsychologicalExaminationAdults = "NeuropsychologicalExaminationAdults",
  NeuropsychiatricExaminationChildrenAndYoungPeopleStep3 = "NeuropsychiatricExaminationChildrenAndYoungPeopleStep3",
  NeuropsychologicalExaminationAdultsStep3 = "NeuropsychologicalExaminationAdultsStep3",
  PsychologicalInvestigationAdults = "PsychologicalInvestigationAdults",
  PsychologicalInvestigationChildrenAndYoungPeople = "PsychologicalInvestigationChildrenAndYoungPeople",
  MedicalExaminationAdults = "MedicalExaminationAdults",
  MedicalExaminationChildrenAndYoungPeople = "MedicalExaminationChildrenAndYoungPeople",
  PrivateAssessmentCall = "PrivateAssessmentCall",
  PrivateNPAssessmentAdults = "PrivateNPAssessmentAdults",
  PrivateNPAssessmentChildrenAndYoung = "PrivateNPAssessmentChildrenAndYoung"
}

export enum PayUnit {
  Hour = "Hour",
  Period = "Period",
  Quantity = "Quantity",
  EmergencyCall = "EmergencyCall",
  WorkShift = "WorkShift",
  Operation = "Operation",
  Investigation = "Investigation"
}

export enum PayPeriod {
  Daily = "Daily",
  FullPeriod = "FullPeriod"
}

export enum ContractsPriceTemplateType {
  CustomerContract = "CustomerContract",
  ConsultantContract = "ConsultantContract"
}
